/*
THIS COMPONENT INCLUDING IN ALL ADMIN PAGES
 ---------------------------------------------*/

import ImageInputManager from './ImageInputAdminManager.js';

let Carousels = (() => {
    const $urlGetItem = '/carousel/getItem';
    const $urlDelete = '/carousel/';
    const $buttonAdd = '.add-item';
    const $buttonDelete = '.delete-item';
    const $containerCarousels = '#carousel-items';
    const container = '.item-container';

    let init = () => {
        listenAdd();
        listenDelete();
    };

    /*
     |--------------------------------------------------------------------------
     | Adding new field
     |--------------------------------------------------------------------------
     */
    let listenAdd = () => {
        $(document).on('click', $buttonAdd, () => {
            let fieldIndex = $(container).length;
            AppendNewField(fieldIndex);
        });
    };

    let AppendNewField = (fieldIndex) => {
        $.get($urlGetItem, {fieldIndex: fieldIndex}).done( (response) => {
            $($containerCarousels).append(response);
            (new ImageInputManager()).init();
        });
    };

    /*
     |--------------------------------------------------------------------------
     | Deleting given field
     |--------------------------------------------------------------------------
     */
    let listenDelete = () => {
        $(document).on('click', $buttonDelete, function () {
            let field = $(this).parents(container);
            let id;
            if (id = field.data('id')) {
                deleteFromDb(id, field);
                return true;
            }

            deleteLocal(field);
        });
    };

    let deleteFromDb = (id, field) => {
        if (confirm('Вы уверены, что хотите удалить это поле?')) {
            $.ajax({
                url: $urlDelete + id,
                method: 'POST',
                data: {
                    _method: 'DELETE'
                }
            }).done(() => {
                field.remove();
            });
        }
    };

    let deleteLocal = (field) => {
        field.remove();
    };

    return {
        init: init
    }
})();

export default Carousels;
